import {default as Config} from '../config'
import { push } from 'react-router-redux'

export default function redirect(dispatch, url) {
	dispatch(push(Config.baseUrl+url));
}


/** WEBPACK FOOTER **
 ** ./js/utils/redirect.js
 **/